// extracted by mini-css-extract-plugin
module.exports = {"aButton":"d_l","cGatsbyBackground":"d_b","animationMarquee":"d_d"};